//grupeering väljatrükiks kuupäeva  järgi
import React, { useRef, useState } from 'react'
import { useAuth } from './Auth//use-auth'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'

// TODO: staatus:puhkus,haige
const useStyles = makeStyles(theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      padding: theme.spacing(3)
    }
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)
  }
}))

function PrintQD (props) {
  const [selectedStartDate, setSelectedStartDate] = useState(
    moment().startOf('day')
  )
  const [selectedEndDate, setSelectedEndDate] = useState(moment().endOf('day'))

  const classes = useStyles()
  //const { auth, user } = useAuth()
  const history = useHistory()
  // useEffect(() => {
  //   //   if (user) {
  // //   }
  //   return () => {
  //     mountedRef.current = false
  //   }
  // }, [])
  const handleDateStartChange = event => {
    setSelectedStartDate(event._d)
  }
  const handleDateEndChange = event => {
    //const newDate = date + ''
    //setIsDisabled(isDisabled => !isDisabled)
    setSelectedEndDate(event._d)
  }
  const handlePrint = e => {
    //e.preventDefault()
    history.push(
      `/printOut/${moment(selectedStartDate).format('x')}/${moment(
        selectedEndDate
      ).format('x')}`
    )
  }
  const handleBack = e => {
    e.preventDefault()
    history.push(`/mb`)
  }
  return (
    <React.Fragment>
      <CssBaseline />
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Grid container spacing={6}>
              <Grid item xs={6} sm={3}>
                <DatePicker
                  size={'small'}
                  allowKeyboardControl={false}
                  id='startDate'
                  format='DD/MM/YY'
                  value={selectedStartDate}
                  onChange={date => handleDateStartChange(date)}
                />
              </Grid>
              <Grid item xs={4} sm={2}>
                Kuni
              </Grid>
              <Grid item xs={6} sm={3}>
                <DatePicker
                  size={'small'}
                  allowKeyboardControl={false}
                  id='endDate'
                  format='DD/MM/YY'
                  value={selectedEndDate}
                  onChange={date => handleDateEndChange(date)}
                />
              </Grid>
            </Grid>
            <div className={classes.buttons}>
              <Button onClick={handleBack} className={classes.button}>
                Tagasi
              </Button>

              <Button
                variant='contained'
                color='primary'
                onClick={handlePrint}
                className={classes.button}
              >
                Prindi
              </Button>
            </div>
          </Paper>
        </main>
      </MuiPickersUtilsProvider>
    </React.Fragment>
  )
}
export default PrintQD

// { JSON.stringify(group, '', 2) }
// { JSON.stringify(jobs, '', 2) }
//   < PrintOut
// algus = { moment(selectedStartDate).format('DD.MM.YY') }
// lopp = { moment(selectedEndDate).format('DD.MM.YY') }
// andmed = { jobs }
//   />
